<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "RoleAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  